import { Component, OnInit } from '@angular/core';
import { NavItem } from "../../../models/navItem";
import { Router, RouterLink } from "@angular/router";
import { NgClass } from "@angular/common";
import { SvgIconComponent } from "angular-svg-icon";
import { EstablishmentService } from "../../../services/establishment.service";
import { CandidatService } from "../../../services/candidat.service";
import { AuthService } from '../../../services/auth.service';
import { PermissionService } from '../../../services/permission.service';
import { AgencyPermission, USER_ACCOUNT_PERMISSIONS } from '../../../shared/utils/agency-rbac';
import { AgencyUsersService } from '../../../services/agency-users.service';

type GatedNavItem = NavItem & { permission?: AgencyPermission | AgencyPermission[] };

@Component({
  selector: 'app-agency-sidebar',
  templateUrl: './agency-sidebar.component.html',
  styleUrl: './agency-sidebar.component.scss',
  imports: [
    NgClass,
    SvgIconComponent,
    RouterLink
  ],
  standalone: true
})
export class AgencySidebarComponent implements OnInit {
  private allNavItems: GatedNavItem[] = [
    {
      id: 1, label: 'Gestion des établissements', icon: 'company', route: '/agency/establishment',
      activatedOn: ['/agency/establishment', '/agency/details-establishment', '/agency/mission-by-establishment']
    },
    {
      id: 2,
      label: 'Gestion des professionnels de santé',
      icon: 'doctor',
      route: 'agency/candidates',
      activatedOn: ['/agency/candidates', '/details-candidate']
    },
    // Lot C (client clinique) : « Gestion de vos agences » masquée — code conservé
    // {
    //   id: 3,
    //   label: 'Gestion de vos agences',
    //   icon: 'agency',
    //   route: 'agency/agencies',
    //   activatedOn: ['/agency/agencies'],
    //   permission: AgencyPermission.AGENCY_SETTINGS
    // },
    {
      id: 4,
      label: 'Gestion des collaborateurs',
      icon: 'padlock-tools',
      route: 'agency/users',
      activatedOn: ['/agency/users', '/agency/details-user'],
      permission: USER_ACCOUNT_PERMISSIONS
    },
    {
      id: 11,
      label: 'Comptes professionnels',
      icon: 'doctor',
      route: 'agency/pro-accounts',
      activatedOn: ['/agency/pro-accounts'],
      permission: AgencyPermission.VALIDATE_PRO_ACCOUNT
    },
    // {
    //   id: 5,
    //   label: 'Gestion centralisée des missions en cours',
    //   icon: 'target',
    //   route: '/agency/missions',
    //   activatedOn: ['/agency/missions']
    // },
    // {
    //   id: 6,
    //   label: 'Rapports Hebdomadaires',
    //   icon: 'document',
    //   route: '/agency/weekly-reports',
    //   activatedOn: ['/agency/weekly-reports']
    // },
    {
      id: 7,
      label: 'Affectation directe',
      icon: 'target',
      route: '/agency/direct-assign',
      activatedOn: ['/agency/direct-assign'],
      permission: AgencyPermission.MISSION_WRITE
    },
    {
      id: 8,
      label: "Relevés d'heures",
      icon: 'document',
      route: '/agency/weekly-hours',
      activatedOn: ['/agency/weekly-hours'],
      permission: AgencyPermission.FINANCE_VIEW
    },
    {
      id: 10,
      label: "Journal d'audit",
      icon: 'document',
      route: '/agency/audit',
      activatedOn: ['/agency/audit'],
      permission: AgencyPermission.AUDIT_VIEW
    },
    // {
    //   id: 9,
    //   label: 'Paie',
    //   icon: 'document',
    //   route: '/agency/payroll',
    //   activatedOn: ['/agency/payroll']
    // },
  ]
  previousUrl: string;

  routeSelected: number | undefined = 1;

  /** Comptes pro en attente de validation (badge du menu « Comptes professionnels »). */
  pendingProCount = 0;

  constructor(private router: Router,
    private auth: AuthService,
    private permissions: PermissionService,
    private etbApi: EstablishmentService,
    private candidateApi: CandidatService,
    private usersService: AgencyUsersService) {
    this.usersService.pendingProCount$.subscribe((count) => this.pendingProCount = count);
    router.events.subscribe((val: any) => {
      if (val.url) {
        this.routeSelected = this.navList.find(a => {
          return a.activatedOn?.filter(p => val.url.includes(p))?.length!! > 0
        })?.id
      }
    });
  }

  /** Entries allowed for the connected role (re-evaluated on each change detection). */
  get navList(): NavItem[] {
    return this.allNavItems.filter((item) => this.permissions.has(item.permission));
  }

  ngOnInit(): void {
    if (this.permissions.has(AgencyPermission.VALIDATE_PRO_ACCOUNT)) {
      this.usersService.refreshPendingProCount();
    }
    // this.etbApi.getAgencyEstablishments().subscribe();
    // this.candidateApi.getAgencyCandidates().subscribe();
  }

  routeClick(item: NavItem) {
    this.router.navigate([item.route])
    this.routeSelected = item.id;
    // le compteur se rafraîchit à chaque navigation (une inscription a pu arriver entre-temps)
    if (this.permissions.has(AgencyPermission.VALIDATE_PRO_ACCOUNT)) {
      this.usersService.refreshPendingProCount();
    }
  }
}
